import './style.scss';

import React, { useEffect } from 'react';
import _ from 'lodash';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';

import { GQL_BROADCAST } from '../../gqls';
import { updatePaginatedData } from '../../utils';
import { broadcastDetails } from '../../actions/broadcast';
import AsyncComponent from '../../components/async-component';

const BroadcastEmailEditor = () => {
  const updateBroadcast = useSelector(state => state.updateBroadcast);

  const dispatch = useDispatch();
  const { id } = useParams();

  const { loading, error, data, fetchMore } = useQuery(GQL_BROADCAST, { variables: { id } });

  const broadcast = _.get(data, 'getBroadcast');
  if (broadcast) dispatch(broadcastDetails(broadcast));

  const updateData = () => {
    fetchMore({
      variables: { id },
      updateQuery: (previousResult, { fetchMoreResult }) =>
        updatePaginatedData('getBroadcast', previousResult, fetchMoreResult),
      notifyOnNetworkStatusChange: true
    });
  };

  useEffect(() => {
    updateData();
  }, [updateBroadcast]);

  if (loading)
    return (
      <div className="fullscreen-div d-flex justify-content-center align-items-center height-100vh">
        <Spinner animation="border" role="status" />
      </div>
    );
  if (error)
    return (
      <div className="fullscreen-div d-flex justify-content-center align-items-center height-100vh">
        {`Error! ${error.message}`}
      </div>
    );
  if (data && !broadcast) window.location.href = process.env.REACT_APP_BASE_URL;

  return <AsyncComponent component={() => import('./content')} />;
};

export default BroadcastEmailEditor;
